// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__105GI","content":"RecentSearches_content__36sWt"};